import { ClosedCases, OpenCases, ProcessingTime, TotalCases } from "icons";

import styles from "./styles.module.scss";
import { NewCard } from "../card";
import { UseApiCallV2 } from "hooks";
import { useLanguageTranslator } from "hooks/use-language-translator";

export const ListOfCards = () => {
  const { data: casesCount, isLoading } = UseApiCallV2({
    url: "/get_summary",
    method: "POST",
    paramsData: {
      temp: "none",
    },
  });

  const { translator } = useLanguageTranslator();
  const countsTrans = translator("casesCounts");
  const countsTooltipTrans = translator("casesCountsTooltip");

  const list = [
    {
      id: 1,
      label: countsTrans.total,
      value: casesCount?.totalCases,
      Icon: TotalCases,
      info: countsTooltipTrans.total,
    },
    {
      id: 2,
      label: countsTrans.open,
      value: casesCount?.pendingCases,
      Icon: OpenCases,
      info: countsTooltipTrans.open,
    },
    {
      id: 3,
      label: countsTrans.closed,
      value: casesCount?.closedCases,
      Icon: ClosedCases,
      info: countsTooltipTrans.closed,
    },
    {
      id: 4,
      label: countsTrans.time,
      value: casesCount?.averageProcessingTimeDays
        ? `${casesCount?.averageProcessingTimeDays} ${translator("days")}`
        : "--",
      Icon: ProcessingTime,
      info: countsTooltipTrans.time,
    },
  ];

  return (
    <div className={styles.listContainer}>
      {list.map((item) => (
        <NewCard key={item.id} item={item} />
      ))}
    </div>
  );
};
